/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 *
 *                _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
 *
 */

/**
 * @module bulb-heading/bulbheadingUi
 */

import {
  Plugin, createDropdown, addToolbarToDropdown, type ButtonView,
} from 'ckeditor5';
import bulbParagraphIcon from '../../assets/block_toolbar_icons/paragraph.svg';
import { BULB_HEADING } from '../../editorcustomconfig.constant';

/**
 * The bulb heading dropdown plugin.
 *
 * @extends Plugin
 */
export default class BulbHeadingUi extends Plugin {

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbHeadingUi' as const;
  }

  /**
   * @inheritDoc
   */
  public init(): void {
    const { editor } = this;
    const { t } = editor;
    const { options } = BULB_HEADING;

    // Register UI component.
    editor.ui.componentFactory.add('bulbHeading', (locale) => {
      const dropdownView = createDropdown(locale);

      const buttons = options.map((option: { model: string; class: string; }) => {
        const paragraphButton = editor.ui.componentFactory.create(option.model);
        if (option.class && paragraphButton.element) {
          paragraphButton.element.classList.add(option.class);
        }
        return paragraphButton;
      });

      // Add existing heading buttons to dropdown's toolbar.
      addToolbarToDropdown(dropdownView, buttons, {
        enableActiveItemFocusOnDropdownOpen: true,
        isVertical: true,
      });

      // Configure dropdown properties and behavior.
      dropdownView.buttonView.set({
        label: t('Heading'),
        icon: bulbParagraphIcon,
        tooltip: true,
      });
      buttons.forEach((element: ButtonView) => {
        element.set({
          withText: true,
          tooltip: false,
          icon: undefined,
        });
      });

      dropdownView.extendTemplate({
        attributes: {
          class: 'ck-heading-dropdown',
        },
      });

      return dropdownView;
    });
  }
}
